module.exports = __webpack_public_path__ + "static/media/crm.a82ac3e0.png";